import { QuizFactory } from "../components/assessmentComp"
import { parseMarkdown } from "../components/createText"
import { TextEditor } from "../components/editorjs"
import { Quiz } from "../screens/quiz"

export const AssessmentFactory = ({module_type,data,clickAnswer,updateOrder,updateMatch,answerText}) => {

    switch(module_type){
        case 1 : return   <QuizFactory
                            clickAnswer={(chosen) => clickAnswer(chosen)}
                            data={data}
                            updateOrder={(value) => updateOrder(value)}
                            updateMatch={(value) => updateMatch(value)}
                            answerText={(value) => answerText(value)}
                        />
        case 2 : return <TextEditor read={true} defaultData={data} placeholder="" />
        case 3 : return <VideoContent data={data}/>
        case "1" : return   <QuizFactory
                            clickAnswer={(chosen) => clickAnswer(chosen)}
                            data={data}
                            updateOrder={(value) => updateOrder(value)}
                            updateMatch={(value) => updateMatch(value)}
                            answerText={(value) => answerText(value)}
                        />
        case "2" : return <TextEditor read={true} defaultData={data} placeholder="" />
        case "3" : return <VideoContent data={data}/>
    }

}

const TextContent = ( {data}) => {
    return (

            <div className="preview-window standard-margin-bottom standard-rounded" dangerouslySetInnerHTML={{ __html: parseMarkdown(data) }}>
            </div>

    )
}
const VideoContent = ({data}) => {
    return (
        <iframe src={data} width="100%" height="350" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
        </iframe>
    )
}